// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"150":"db3ccf05","1471":"18941e73"}[chunkId] + ".chunk.css";
};